import React, { useState, useEffect, useRef } from "react";
import { Autocomplete, Checkbox, Chip, CircularProgress, createFilterOptions, FormHelperText, Grid, TextField } from "@mui/material";
import { connect } from "react-redux";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { PublicService } from "../../../../../../core/services";
// import { InfluencerSelector } from "../../../../../../components/influencer-selector/influencer-selector";
import { DeliverablesComponent } from '../campaign-deliverables';
// import { CampaignDeliverables } from '../../../../../../core/models';
import { TransformDeliverables } from '../de-comman';
import { CreateCampaign } from '../../../../../../core/services/createcampaign.service';
import { TrashIcon2 } from '../../../../../../assets/icons/common-icons';
import "./campaign-influencer-all.scss";
import { Link } from "react-router-dom";
import { MenuPropsAutoComplete, MenuPropsSelectSmall } from "../../../../../../core/utility/style";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";

const publicService = new PublicService();
const transform: TransformDeliverables = new TransformDeliverables();


type IntialFormData = {
  deliverable: string;
  ig_static_image: number | null;
  quantity: number | null;
  influencer_type: number[];
};

const intialFormData: IntialFormData = {
  deliverable: '',
  ig_static_image: null,
  quantity: null,
  influencer_type: []
};

interface Props {
  open_all: any;
  updateOpen_all: (data: any) => void;
  platformType: 'instagram' | 'youtube';
  campaignReducer: any;
  UserReducer: any;
  getValidationStatus: any;
  getSubscriptionDetail: any;
}

const CampaingInfluencerAll: React.FC<Props> = (props: Props) => {
  const [categoryList, setCategoryList] = useState([]);
  const [countries, setCountries] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  const [selectedCountries, setSelectedCountries] = useState<any[]>([]);
  const [selectedStates, setSelectedStates] = useState<any[]>([]);
  const [selectedCities, setSelectedCities] = useState<any[]>([]);
  const [statesLoading, setStatesLoading] = useState(false);
  const [citiesLoading, setCitiesLoading] = useState(false);
  const [formDataCollection, setFormDataCollection] = useState<IntialFormData[]>([]);
  const [formData, setFormData] = useState<IntialFormData>(intialFormData);
  const [error, setError] = useState<number | null>();
  const [selectOpen, setSelectOpen] = useState(false);
  const defaultCountryAppliedRef = useRef(false);

  useEffect(() => {
    PublicService.getGenre()
      .then((res: any) => {
        setCategoryList(res.data.rows);
      })
      .catch((err) => {
        throw new Error(`Error get Genre :: ${err}`);
      });

    publicService.getCountry({})
      .then((res: any) => {
        if (res?.status === 1) setCountries(res.data || []);
        else setCountries([]);
      })
      .catch(() => setCountries([]));
  }, []);

  useEffect(() => {
    props.updateOpen_all({ influencer_selector: transform.transformCollectionForDatabase(formDataCollection) })
  }, [formDataCollection]);

  useEffect(() => {
    /* Filter Data the data set according to platfrom like instagram, youtube and etc...  */
    let temp: any[] = [];
    let platfrom = '';
    switch ((props.platformType).toLowerCase()) {
      case 'instagram':
        platfrom = 'ig';
        break;
      case 'youtube':
        platfrom = 'yt';
        break;
      default:
        platfrom = 'ig';
        break;
    };

    CreateCampaign.getDeliverables(props.campaignReducer.createCampaign.campaign_id).then((res: any) => {
      if (res.data.status > 0) {
        for (let data of transform.transformDbForFormObj(res.data.rows)) {
          if (['digital_rights', 'available_for_exclusivity'].includes(data.deliverable)) {
            temp.push(data);
          } else if (data.deliverable.includes(platfrom)) {
            temp.push(data);
          }
        }
        setFormDataCollection(temp);
      }
    })

    // /* Validation Skip on digital rights and available_for_exclusivity these are prefill */
    // for (let data of transform.transformDbForFormObj(props.open_all.influencer_selector)) {
    //   if (['digital_rights', 'available_for_exclusivity'].includes(data.deliverable)) {
    //     temp.push(data);
    //   } else if (data.deliverable.includes(platfrom)) {
    //     temp.push(data);
    //   }
    // }
    // setFormDataCollection(temp)
  }, [])

  // Location country is fixed to India (not user-editable) for brand campaigns.
  // Once countries load, force-select India, restore any saved states/cities
  // under it, and skip re-running on later renders via the ref guard.
  useEffect(() => {
    if (defaultCountryAppliedRef.current) return;
    if (countries.length === 0) return;
    defaultCountryAppliedRef.current = true;
    const india = countries.find(
      (c: any) => (c.country_code || '').toLowerCase() === 'in' || (c.name || '').trim().toLowerCase() === 'india'
    );
    if (!india) return;
    setSelectedCountries([india]);
    if (props.open_all.country_ids?.length !== 1 || props.open_all.country_ids[0] !== india.id) {
      props.updateOpen_all({
        country_ids: [india.id],
        campaign_locations: buildCampaignLocations([india], [], []),
      });
    }
    fetchStatesForCountries([india]).then((fetchedStates) => {
      if (!props.open_all.state_ids?.length || !fetchedStates.length) return;
      const restoredStates = fetchedStates.filter((s: any) => props.open_all.state_ids.includes(s.id));
      setSelectedStates(restoredStates);
      if (!restoredStates.length) return;
      fetchCitiesForStates(restoredStates).then((fetchedCities) => {
        if (!props.open_all.city_ids?.length || !fetchedCities.length) return;
        setSelectedCities(fetchedCities.filter((c: any) => props.open_all.city_ids.includes(c.id)));
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countries]);

  const fetchStatesForCountries = async (countriesList: any[]): Promise<any[]> => {
    if (!countriesList.length) { setStates([]); return []; }
    setStatesLoading(true);
    try {
      const results = await Promise.all(
        countriesList.map((country) => {
          const dialing_code = (country.dialing_code || country.dial_code || '').replace(/^\+/, '');
          return publicService.getState({ dialing_code, country_id: country.id});
        })
      );
      const seen = new Set<any>();
      const merged: any[] = [];
      for (const res of results) {
        for (const s of res?.status === 1 ? res.data || [] : []) {
          if (!seen.has(s.id)) { seen.add(s.id); merged.push(s); }
        }
      }
      setStates(merged);
      return merged;
    } catch {
      setStates([]);
      return [];
    } finally {
      setStatesLoading(false);
    }
  };

  const fetchCitiesForStates = async (statesList: any[]): Promise<any[]> => {
    if (!statesList.length) { setCities([]); return []; }
    setCitiesLoading(true);
    try {
      const results = await Promise.all(
        statesList.map((state) => publicService.getCity({ state_id: state.id }))
      );
      const seen = new Set<any>();
      const merged: any[] = [];
      for (const res of results) {
        for (const c of res?.status === 1 ? res.data || [] : []) {
          if (!seen.has(c.id)) { seen.add(c.id); merged.push(c); }
        }
      }
      setCities(merged);
      return merged;
    } catch {
      setCities([]);
      return [];
    } finally {
      setCitiesLoading(false);
    }
  };

  const buildCampaignLocations = (selCountries: any[], selStates: any[], selCities: any[]) => {
    const locations: { country_id: number; state_id: number | null; city_id: number | null }[] = [];
    const stateIdsWithCities = new Set(selCities.map((c: any) => c.state_id));
    const countryIdsWithStates = new Set(selStates.map((s: any) => s.country_id));

    for (const city of selCities) {
      locations.push({ country_id: city.country_id, state_id: city.state_id, city_id: city.id });
    }
    for (const state of selStates) {
      if (!stateIdsWithCities.has(state.id)) {
        locations.push({ country_id: state.country_id, state_id: state.id, city_id: null });
      }
    }
    for (const country of selCountries) {
      if (!countryIdsWithStates.has(country.id)) {
        locations.push({ country_id: country.id, state_id: null, city_id: null });
      }
    }
    return locations;
  };

  const handleStateChange = async (_e: any, newValue: any[]) => {
    const newStateIds = new Set(newValue.map((s) => s.id));
    const prevStateIds = new Set(selectedStates.map((s: any) => s.id));
    const addedStates = newValue.filter((s) => !prevStateIds.has(s.id));
    const removedStateIdSet = new Set(
      selectedStates.filter((s: any) => !newStateIds.has(s.id)).map((s: any) => s.id)
    );

    // Drop cities that belonged to removed states (cities have state_id from the API)
    const newCitiesList = cities.filter((c: any) => !removedStateIdSet.has(c.state_id));
    const newCityIdSet = new Set(newCitiesList.map((c: any) => c.id));
    const newSelectedCities = selectedCities.filter((c: any) => newCityIdSet.has(c.id));

    setSelectedStates(newValue);
    setSelectedCities(newSelectedCities);
    setCities(newCitiesList);
    props.updateOpen_all({
      state_ids: newValue.map((s) => s.id),
      city_ids: newSelectedCities.map((c: any) => c.id),
      campaign_locations: buildCampaignLocations(selectedCountries, newValue, newSelectedCities),
    });

    // Fetch and merge cities only for newly added states
    if (addedStates.length > 0) {
      setCitiesLoading(true);
      try {
        const results = await Promise.all(
          addedStates.map((state) => publicService.getCity({ state_id: state.id }))
        );
        const seen = new Set(newCitiesList.map((c: any) => c.id));
        const merged = [...newCitiesList];
        for (const res of results) {
          for (const c of res?.status === 1 ? res.data || [] : []) {
            if (!seen.has(c.id)) { seen.add(c.id); merged.push(c); }
          }
        }
        setCities(merged);
      } catch {
        // keep trimmed list already set above
      } finally {
        setCitiesLoading(false);
      }
    }
  };

  const handleCityChange = (_e: any, newValue: any[]) => {
    setSelectedCities(newValue);
    props.updateOpen_all({
      city_ids: newValue.map((c) => c.id),
      campaign_locations: buildCampaignLocations(selectedCountries, selectedStates, newValue),
    });
  };

  /**
   * Handles the change event of the category select input.
   *
   * @param event - The select change event.
   */
  const handleChange = (
    event: SelectChangeEvent<typeof props.open_all.category>
  ) => {
    if(props.getSubscriptionDetail && props.getSubscriptionDetail.isBasicUser && ((props.campaignReducer.createCampaign.campaign_type).toLowerCase() === 'paid')){
      const {
        target: { value },
      } = event;
      if (value.length > 2) {
        props.getValidationStatus.category.status = false
        props.getValidationStatus.category.message = (
          <>
            You can select upto 2 categories.{' '}
            <Link to="/brand/settings/subscription">Upgrade</Link> to select more categories.
          </>
        );
        setSelectOpen(false);
      } else {
        props.updateOpen_all({ category: value });
      }
    }else{
      const {
        target: { value },
      } = event;
      props.updateOpen_all({ category: value });
    }
    
  };
  
  const handleOpen = () => {
    setSelectOpen(true);
  };

  const handleClose = () => {
    setSelectOpen(false);
  };

  
  useEffect(() => {

  }, [props.getValidationStatus])
  function handleAddDeliverables() {
    if(formData.deliverable === "ig_static"){
      if (formData.quantity === null || formData.influencer_type.length === 0 || formData.ig_static_image === null) {
        return;
      }
    }
    if (formData.deliverable === "" ||formData.quantity === null || formData.influencer_type.length === 0) {
      return;
    }
    setFormDataCollection([...formDataCollection, formData]);
    setFormData(intialFormData);
  }

  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    limit: 500,
  });

  // Keeps the field a single line always — MUI's own `limitTags` prop only
  // collapses chips while the field is blurred, so it still overflows while
  // the user is actively selecting. This renders a fixed "first chip + N"
  // summary regardless of focus state.
  const locationAutocompleteSx = {
    width: '100%',
    '& .MuiAutocomplete-inputRoot': {
      flexWrap: 'nowrap',
    },
  };

  const renderLimitedTags = (maxVisible: number) => (value: any[], getTagProps: any) => {
    const visible = value.slice(0, maxVisible);
    const hiddenCount = value.length - visible.length;
    return (
      <>
        {visible.map((option: any, index: number) => (
          <Chip {...getTagProps({ index })} key={option.id} size="small" label={option.name} />
        ))}
        {hiddenCount > 0 && <Chip key="more" size="small" label={`+${hiddenCount}`} />}
      </>
    );
  };


  return (
    <div className="container-fluid camp_inf_main_container">
      <div className="row">
        <div className="col">
          <h5>Influencer Details</h5>
        </div>
      </div>
      <div className="row">
        <div className="col-md-2">Gender</div>
        <div className="col-md-10">
          <FormControl className="d-flex flex-row mb-3">
            <RadioGroup
              defaultValue="any"
              onChange={(e) => props.updateOpen_all({ gender: e.target.value })}
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                className="me-4"
                value="any"
                control={
                  <Radio
                    style={{
                      padding: 0,
                      paddingRight: "5px",
                    }}
                  />
                }
                label="Any"
              />
              <FormControlLabel
                className="me-4"
                value="male"
                control={
                  <Radio
                    style={{
                      padding: 0,
                      paddingRight: "5px",
                    }}
                  />
                }
                label="Male"
              />
              <FormControlLabel
                className="me-4"
                value="female"
                control={
                  <Radio
                    style={{
                      padding: 0,
                      paddingRight: "5px",
                    }}
                  />
                }
                label="Female"
              />
            </RadioGroup>
          </FormControl>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-md-2">Category</div>
        <div className="col-md-10">
          <FormControl fullWidth size="small">
            <InputLabel id="demo-multiple-name-label">Category</InputLabel>
            <Select
              className="custom_category"
              labelId="demo-multiple-name-label"
              id="demo-multiple-name"
              multiple
              value={props.open_all.category}
              onChange={handleChange}
              onClose={handleClose}
              onOpen={handleOpen}
              open={selectOpen}
              input={
                <OutlinedInput
                  error={!props.getValidationStatus.category.status}
                  label="Category"
                />
              }
              renderValue={(selected) =>
                categoryList
                  .filter((cat:any) => selected.includes(cat.category_id))
                  .map((cat:any) => cat.category)
                  .join(", ")
              }
              MenuProps={MenuPropsSelectSmall}
            >
              {categoryList.length > 0 ? (
                categoryList.map((cat: { category_id: number; category: string }) => (
                  <MenuItem key={cat.category_id} value={cat.category_id}>
                    <Checkbox
                                    className='custom-checkbox'
                                        icon={<CheckBoxOutlineBlank fontSize="small" />}
                                        checkedIcon={<CheckBox fontSize="small" />}
                                        style={{ marginRight: 8 }}
                                        checked={props.open_all.category.includes(cat.category_id)}
                                    />
                    {/*  */}
                    {cat.category}
                  </MenuItem>
                ))
              ) : (
                <MenuItem key={1} value={""}>
                  No Data
                </MenuItem>
              )}
            </Select>
          </FormControl>
          {!props.getValidationStatus.category.status && <span className="error">{props.getValidationStatus.category.message}</span>}
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-md-2">Location</div>
        <div className="col-md-10">
          <Grid container spacing={{ xs: 2, md: 3 }}>
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                multiple
                size="small"
                disableCloseOnSelect
                disabled
                options={countries}
                value={selectedCountries}
                getOptionLabel={(option: any) => option.name || ''}
                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                filterOptions={filterOptions}
                ListboxProps={MenuPropsAutoComplete.PaperProps}
                sx={locationAutocompleteSx}
                renderTags={renderLimitedTags(1)}
                renderOption={(optProps: any, option: any, { selected }: any) => (
                  <li {...optProps}>
                    <Checkbox
                      icon={<CheckBoxOutlineBlank fontSize="small" />}
                      checkedIcon={<CheckBox fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.name}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Country"
                    error={!props.getValidationStatus.location.status}
                    inputProps={{ ...params.inputProps, autoComplete: 'off' }}
                  />
                )}
              />
              {!props.getValidationStatus.location.status && (
                <span className="error">{props.getValidationStatus.location.message}</span>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                multiple
                size="small"
                disableCloseOnSelect
                disabled={selectedCountries.length === 0}
                loading={statesLoading}
                options={states}
                value={selectedStates}
                onChange={handleStateChange}
                getOptionLabel={(option: any) => option.name || ''}
                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                filterOptions={filterOptions}
                ListboxProps={MenuPropsAutoComplete.PaperProps}
                sx={locationAutocompleteSx}
                renderTags={renderLimitedTags(1)}
                renderOption={(optProps: any, option: any, { selected }: any) => (
                  <li {...optProps}>
                    <Checkbox
                      icon={<CheckBoxOutlineBlank fontSize="small" />}
                      checkedIcon={<CheckBox fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.name}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="State"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {statesLoading ? <CircularProgress color="inherit" size={16} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                    inputProps={{ ...params.inputProps, autoComplete: 'off' }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <Autocomplete
                multiple
                size="small"
                disableCloseOnSelect
                disabled={selectedStates.length === 0}
                loading={citiesLoading}
                options={cities}
                value={selectedCities}
                onChange={handleCityChange}
                getOptionLabel={(option: any) => option.name || ''}
                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                filterOptions={filterOptions}
                ListboxProps={MenuPropsAutoComplete.PaperProps}
                sx={locationAutocompleteSx}
                renderTags={renderLimitedTags(1)}
                renderOption={(optProps: any, option: any, { selected }: any) => (
                  <li {...optProps}>
                    <Checkbox
                      icon={<CheckBoxOutlineBlank fontSize="small" />}
                      checkedIcon={<CheckBox fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.name}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="City"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {citiesLoading ? <CircularProgress color="inherit" size={16} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                    inputProps={{ ...params.inputProps, autoComplete: 'off' }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-md-2">
          Deliverables
        </div>
        <div className="col">
          <Grid container spacing={{ xs: 2, md: 3 }} alignItems="flex-start">
            <Grid item xs={12} md>
              <DeliverablesComponent
                formDataCollection={formDataCollection}
                value={formData}
                deliverable_type={formData.deliverable}
                platform={props.platformType}
                onChange={(values: any) => setFormData(values)} />
                {!props.getValidationStatus.deliverables.status && <span className="error">{props.getValidationStatus.deliverables.message}</span>}
            </Grid>
            <Grid item xs={12} md="auto">
              <button onClick={handleAddDeliverables} className="btn btn-primary">Add Deliverable</button>
            </Grid>
          </Grid>
        </div>
      </div>
      <div className="row justify-content-end">

        <div className="col-md-10 mt-3">
          {
            formDataCollection.map((data, index) => {
              let deliverable = <div className="row mb-3" key={index}>
                <div className="col">
                  <DeliverablesComponent
                    platform={props.platformType}
                    disableDeliverables={true}
                    disableNoOfImages={true}
                    formDataCollection={formDataCollection}
                    deliverable_type={data.deliverable}
                    value={data}
                    error={error === index && true}
                    onChange={(values: any) => {
                      if(values.influencer_type.length > 0){
                        let temp = [...formDataCollection];
                        temp[index] = values;
                        setFormDataCollection(temp);
                        setError(null);
                      }else{
                        setError(index);
                      }
                    }} />
                </div>
                <div className="col-auto">
                  <span 
                  onClick={() => {
                    let temp = [...formDataCollection];
                    temp.splice(index, 1);
                    setFormDataCollection(temp);
                  }}
                  >
                    <TrashIcon2 size={30} />
                  </span>
                </div>
              </div>

              return deliverable;
            }
            )
          }
        </div>
      </div>
      {/* <div className="row mb-3">
        <div className="col-md-2">Type:</div>
        <div className="col-md-10">
          <InfluencerSelector
            influencerSelectorData={props.open_all.influencer_selector}
            updateInfluencerSelectorData={(e) =>
              props.updateOpen_all({
                influencer_selector: {
                  ...props.open_all.influencer_selector,
                  ...e,
                },
              })
            }
            platformType={props.platformType + ""}
          />
        </div>
      </div> */}

      <div className="col">
        <FormControl className="row w-100 d-flex flex-row">
          {props.campaignReducer.createCampaign.campaign_type
            .toString()
            .toLocaleLowerCase()
            .includes("paid") && (
              <div className="col-md-2">
                <FormLabel id="id_rb-costing-only">
                  <span className="field_header" style={{marginLeft:"-11px", color:"#2b2b2b"}}> Costing Model </span>{" "}
                </FormLabel>
              </div>
            )}
          <div className="col-md-10">
            <RadioGroup
              defaultValue="individual"
              className="p-0"
              onChange={(e) =>
                props.updateOpen_all({
                  costing_module: e.target.value,
                })
              }
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="rb-costing-only"
            >
              {props.campaignReducer.createCampaign.campaign_type
                .toString()
                .toLocaleLowerCase()
                .includes("paid") && (
                  <div className="row w-100 mt-0">
                    <div className="d-flex flex-column col-md-6 input-w-helper">
                      <FormControlLabel
                        value="individual"
                        control={<Radio className="p-0 me-2" />}
                        label="Individual Deliverable Costing"
                      />
                      <FormHelperText>
                      <ul style={{listStyle:'inherit'}}>
                        <li>This model provides the cost for each deliverable individually.</li>
                        <li>It allows you to negotiate the price for each deliverable separately.</li>
                        <li>Ideal if you have not yet finalized the exact deliverables.</li>
                      </ul>
                    
                    </FormHelperText>
                    </div>
                    <div className="d-flex flex-column col-md-6 ">
                      <FormControlLabel
                        value="package"
                        control={<Radio className="p-0 me-2" />}
                        label="Package Costing"
                      />
                      {/* <span className="fs-14  input-w-helper-text">
                        This will allow you to get the cost of complete package.
                      </span> */}
                      <FormHelperText>
                      <ul style={{listStyle:'inherit'}}>
                      <li>This model offers a single package cost for all deliverables combined.</li>
                      <li>It enables you to negotiate the total price at the package level.</li>
                      <li>Best suited if you have finalised all the deliverables in advance.</li>
                      </ul>
                    
                    </FormHelperText>
                    </div>
                  </div>
                )}
            </RadioGroup>
          </div>
        </FormControl>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
    campaignReducer: state.CreateCampaignReducer,
    getSubscriptionDetail: state.Subscription.subscription_detail
  };
};

const connectToRedux = connect(mapStateToProps, null)(CampaingInfluencerAll);

export { connectToRedux as CampaingInfluencerAll };
